import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';

const TribunUpdateNicknameModal = props => {

  /*const buttonConfig = {
    primary: {
      label: 'Tamam',
      onClick: props.onPrimaryButtonClick
    }
  };*/

  const successMessage = EnvironmentManager.getMessageText({ key: 'tribun_username_update_message' });

  return (
    <Message type="none" >
      <p dangerouslySetInnerHTML={ { __html: successMessage } } />
    </Message>
  );
};

TribunUpdateNicknameModal.propTypes = {
  userName: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func.isRequired
};

export default TribunUpdateNicknameModal;
